import {Store, Module, ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import HandoverSession from '../entities/handoversession';
import HandoverSessionDetail from '../entities/handoversessiondetail'
import HandoverSessionUpdateDetail from '../entities/handover-session-detail-for-update'

import PackageInfo from '../entities/handoversessionpackageinfo'
import Ref from '../entities/ref';
import Invoice from '../entities/invoice';
interface HandoverSessionState extends ListState<HandoverSession>{
    editHandoverSession:HandoverSession,
    viewHandoverSession: HandoverSession,
    sessionTypes : Ref[],
    sessionStatuses: Ref[],
    sessionItemTypes: Ref[]

}
class HandoverSessionMutations extends ListMutations<HandoverSession>{

}
class HandoverSessionModule extends ListModule<HandoverSessionState,any,HandoverSession>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<HandoverSession>(),
        loading:false,
        editHandoverSession:new HandoverSession(),
        viewHandoverSession: new HandoverSession(),
        sessionTypes: new Array<Ref>(),
        sessionStatuses : new Array<Ref>(),
        sessionItemTypes : new Array<Ref>()
    }
    actions={
        async getAll(context:ActionContext<HandoverSessionState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ViewHoSession/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<HandoverSession>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async get(context:ActionContext<HandoverSessionState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/HandOverSession/GetDetail?Id='+payload.data.id);
            return reponse.data.result as HandoverSessionDetail;
        },
        async getForUpdate(context:ActionContext<HandoverSessionState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/HandOverSession/GetHandOverSessionForUpdate?Id='+payload.data.id);
            return reponse.data.result as HandoverSessionUpdateDetail;
        },
        async delete(context:ActionContext<HandoverSessionState,any>,payload:any){
            await Ajax.delete('/api/services/app/HandOverSession/Delete?Id='+payload.data);
        },
        async transfer(context:ActionContext<HandoverSessionState,any>,payload:any){
            let reponse=await Ajax.post('/api/services/app/HandOverSession/Transfer',payload.data);
            return reponse.data.result;
        },
        async scancode(context:ActionContext<HandoverSessionState,any>,payload:any){
            let response = await Ajax.get('/api/services/app/HandOverSession/GetItemInfos',{params:payload.data});
            return response.data.result as Array<PackageInfo>;
        },
        async create(context: ActionContext<HandoverSessionState, any>, payload: any) {
            let response= await Ajax.post('/api/services/app/HandOverSession/Create', payload.data);
            return response.data.result;
        },
        async update(context: ActionContext<HandoverSessionState, any>, payload: any) {
            await Ajax.put('/api/services/app/HandOverSession/Update', payload.data);
        },
        async getSessionTypes(context:ActionContext<HandoverSessionState,any>){
            let reponse=await Ajax.get('/api/services/app/HandOverSession/GetSessionTypes');
            context.state.sessionTypes=reponse.data.result as Ref[];
        },
        async getSessionStatuses(context:ActionContext<HandoverSessionState,any>, payload: any){
            let reponse=await Ajax.get('/api/services/app/HandOverSession/GetSessionStatuses',{ params : payload.data });
            context.state.sessionStatuses=reponse.data.result as Ref[];
        },
        async getSessionItemTypes(context:ActionContext<HandoverSessionState,any>){
            let reponse=await Ajax.get('/api/services/app/HandOverSession/GetSessionItemTypes');
            context.state.sessionItemTypes= reponse.data.result as Ref[];
        },
        async getInfoInvoiceOrderTransferOfSoInSession(context:ActionContext<HandoverSessionState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/HandOverSession/GetInfoInvoiceOrderTransferOfSoInSession?Id='+payload.data.id);
            return reponse.data.result as Invoice;
        },
        async getHandoverSessionAOGroupReport(context:ActionContext<HandoverSessionState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/HandOverSession/GetHandoverSessionAOGroupReport?Id='+payload.data.id);
            return reponse.data.result;
        },
        async getHandoverSessionTplReport(context:ActionContext<HandoverSessionState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/HandOverSession/GetHandoverSessionTplReport?Id='+payload.data.id);
            return reponse.data.result;
        },
    };
    mutations={
        setCurrentPage(state:HandoverSessionState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:HandoverSessionState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:HandoverSessionState,handoverSession:HandoverSession){
            state.editHandoverSession=handoverSession;
        },
        view(state: HandoverSessionState, handoverSession:HandoverSession) {
            state.viewHandoverSession = handoverSession;
        },
        refreshListData(state: HandoverSessionState)
        {
            state.list = new Array<HandoverSession>();
        }
    }
}
const handoverSessionModule=new HandoverSessionModule();
export default handoverSessionModule;